import { useCallback } from "react";
import {
  Container,
  Typography,
  makeStyles,
  Box,
} from "@material-ui/core";
import { ITheme } from "../constants/theme";
import {
  CollectOrderStamp,
  CollectOrderStatus,
} from "../components-molecules/CollectOrderStamp";
import BackButton from "../components-atoms/BackButton";
import { Stamp } from "../components-atoms/Stamp";
import { useHistory } from "react-router-dom";
import { ButtonPrimary } from "../components-atoms";
import ReplayIcon from '@material-ui/icons/Replay';

interface ICollectionOrderHeaderProps {
  title: string;
  id?: string;
  isAdmin?: boolean;
  isMerchant?: boolean;
  portalStatus?: string;
  headerRight?: any;
  status?: CollectOrderStatus;
  premiumSelected?: boolean;
  from?: string | null;
  manuallyResolved?: boolean;
}

export function CollectionOrderHeader({
  id,
  isAdmin,
  isMerchant,
  title,
  portalStatus,
  headerRight,
  status,
  premiumSelected,
  from,
  manuallyResolved
}: ICollectionOrderHeaderProps) {
  const history = useHistory<{ from: string }>();
  const classes = useStyles();
  const onBack = () => {
    if (from === "form" || window.history.length <= 2) {
      window.location.href = "/delivery-orders";
    } else {
      history.goBack();
    }
  };

  const getStatusText = useCallback(() => {
    switch (portalStatus) {
      case "Open":
        return "Open Orders";
      case "Archived":
        return "Archived";
      case "OutForDelivery":
        return "In Transit";
      default:
        return "Open Orders";
    }
  }, [portalStatus]);

  const repeatBooking = () => {
    history.push("/new-delivery-order?repeatBookingId=" + id);
  }

  return (
    <Container className={classes.header}>
      <BackButton onClick={onBack} />
      <Box className={classes.headerLeft}>
        <Typography variant="body1" component="p" color="textSecondary">
          {getStatusText()}
        </Typography>
        <Box className={classes.titleSection}>
          <Typography variant="h5" component="h1" color="textPrimary">
            {title}
          </Typography>
          <Box className={classes.stampContainer}>
            {status &&
              <CollectOrderStamp status={status} />
            }
            {premiumSelected &&
              <Stamp type="success" text="Concierge" />
            }
            {manuallyResolved &&
              <Stamp type="warning" text="Manually Resolved" />
            }
          </Box>

        </Box>
      </Box>
      <Box className={classes.headerRight}>
        {headerRight?.()}
        {(id && id.length > 0 && !isAdmin && !isMerchant) &&
          <ButtonPrimary
            startIcon={<ReplayIcon />}
            style={{ width: 170 }}
            onClick={repeatBooking}>
            Repeat Booking
          </ButtonPrimary>
        }
      </Box>
    </Container>
  )
}

const useStyles = makeStyles((myTheme: ITheme) => ({
  header: {
    display: 'flex',
    gap: 16,
    maxWidth: 1200,
    paddingLeft: 0,
    paddingRight: 0,
  },
  headerLeft: {
    display: 'flex',
    flexDirection: 'column',
    flex: 1,
    textAlign: 'left',
    marginRight: 16
  },
  titleSection: {
    display: 'flex',
    alignItems: 'center',
    overflow: 'hidden',
    whiteSpace: 'normal',
    wordBreak: 'break-word',
    '& h1': {
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      display: '-webkit-box',
      WebkitLineClamp: 1,
      WebkitBoxOrient: 'vertical',
    },
  },
  headerRight: {
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center',
    gap: 16,
  },
  stampContainer: {
    display: 'flex',
    marginTop: 4,
  },
}));
